<template>
  <div class="worklist">
    <!-- <div class="item" @click="workDetailsInfo(v.id, v.activity_type)">
          <img class="imageFm" :src="v.image[0]" />
          <div class="title yh" :title="`${v.name}`">{{ v.name }}</div>
          <div class="text_line yh" :title="`作者：${v.username}`">
            {{ label_name }}：{{ v.username }}
          </div>
          <div class="text_line yh" :title="`学校：${v.from}`">
            {{ label_unit }}：{{ v.from }}
          </div>
          <div class="text_line yh" :title="`时间：${v.created_at}`">
            时间：{{ v.created_at }}
          </div>
          <index-icons
            :goodsnum="v.mark"
            :commentnum="v.comment"
            :looknum="v.views"
          ></index-icons>
        </div> -->
    <!-- <el-row :gutter="25" style="display: flex;flex-wrap: wrap;">
      <div class="card" :span="8" v-for="(v, index) of worksList" :key="index">
        

        <router-link
          :to="`/workdetails/${v.id}/${v.activity_type}`"
          class="item"
          @click="workDetailsInfo(v.id, v.activity_type)"
          target="_blank"
        >
          <img class="imageFm" :src="v.image[0]" />
          <div class="title " :title="`${v.name}`">{{ v.name }}</div>
          <div class="text_line " :title="`作者：${v.username}`">
            {{ label_name }}：{{ v.username }}
          </div>
          <div class="text_line " :title="`学校：${v.from}`">
            {{ label_unit }}：{{ v.department ? v.department : v.from }}
          </div>
          <div class="text_line " :title="`时间：${v.created_at}`">
            时间：{{ v.created_at }}
          </div>
          <index-icons
            :goodsnum="v.mark"
            :commentnum="v.comment"
            :looknum="v.views"
          ></index-icons>
        </router-link>
      </div>
    </el-row> -->
    <div class="card" :span="8" v-for="(v, index) of worksList" :key="index">
      <router-link
        :to="`/workdetails/${v.id}/${v.activity_type}`"
        class="item"
        @click="workDetailsInfo(v.id, v.activity_type)"
        target="_blank"
      >
        <img class="imageFm" :src="v.image[0]" />
        <div class="title " :title="`${v.name}`">{{ v.name }}</div>
        <div class="text_line " :title="`作者：${v.username}`">
          {{ label_name }}：{{ v.username }}
        </div>
        <div class="text_line " :title="`学校：${v.from}`">
          {{ label_unit }}：{{ v | unit_filt }}
        </div>
        <div class="text_line " :title="`时间：${v.created_at}`">
          时间：{{ v.created_at }}
        </div>
        <index-icons
          :goodsnum="v.mark"
          :commentnum="v.comment"
          :looknum="v.views"
          :ShowComment="true"
        ></index-icons>
      </router-link>
    </div>
  </div>
</template>
<script>
import IndexIcons from "@/components/Icons";
export default {
  name: "WorkList",
  props: ["worksList"],
  components: {
    IndexIcons
  },
  data() {
    return {};
  },
  methods: {
    workDetailsInfo(id, type) {
      console.log(id, type);
      this.$router.replace("/workdetails/" + id + "/" + type);
    }
  },
  computed: {
    label_name() {
      let id = this.$route.params.id;
      if (+id === 426 || +id == 1001) {
        return `参赛者姓名`;
      } else {
        return "作者";
      }
    },
    label_unit() {
      let id = this.$route.params.id;
      if (+id === 426 || +id == 1001) {
        return `参赛者单位`;
      } else {
        return "学校";
      }
    },


    unit_value() {
      let id = this.$route.params.id;
      if (+id === 426 || +id == 1001) {
        return `参赛者单位`;
      } else {
        return "学校";
      }
    }
  },
  filters: {
    unit_filt(value) {
      let id = value.activity_id;
      if (+id === 426 || +id == 1001) {
        return value.department;
      } else {
        return value.from;
      }
    }
  }
};
</script>

<style scoped lang="less">
.worklist {
  margin-top: 30px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  .card {
    margin: 0 auto 30px 0;
    width: 256px;
    &:nth-child(4n) {
      margin: 0 0 30px 0;
    }
  }
}

.imageFm {
  width: 262px;
  height: 260px;
  object-fit: cover;
  border-radius: 10px;
  box-shadow: 0 0 10px 1px #ddd;
}
.item {
  // width: 262px;
  margin: 0 auto 40px auto;
}
.title {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin: 14px 0px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text_line {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  margin-top: 8px;
}

// @media (min-width: 1024px) {
//   .item {
//     height: 500px;
//   }
// } /*>=1024的设备*/

// @media (min-width: 1280px) {
//   .item {
//     height: 400px;
//   }
// } /*>=1280的设备*/
</style>



// WEBPACK FOOTER //
// src/works/components/Lists.vue